import { ReactEditor } from "slate-react";
import { Path, Transforms } from "slate";
import { focusEditor } from "../../utilities/index";
export const toCssValue = (value) => {
    if (value === undefined || typeof value === "number") {
        return value;
    }
    // Return a number, numeric string as a number, or return a string css value (eg, 10px)
    return /^\d*$/.test(value || "") ? Number(value) : value;
};
export const numericCssProperties = [
    "borderRadius",
    "height",
    "marginBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "width"
];
export const defaultImageState = { isAspectRatioLocked: true, isMarginLocked: true };
export const imageStateReducer = (prevState, action) => {
    const nextState = { ...defaultImageState, ...prevState, ...action };
    numericCssProperties.forEach((key) => {
        if (key in nextState) {
            // Convert number strings to numbers
            nextState[key] = toCssValue(nextState[key]);
        }
    });
    return nextState;
};
export const getStyleFromImageState = (imageState) => {
    const imageStyles = { marginTop: 4 };
    imageStyles.marginTop = imageState.marginTop;
    if (imageState.isMarginLocked) {
        imageStyles.marginRight = imageState.marginTop;
        imageStyles.marginBottom = imageState.marginTop;
        imageStyles.marginLeft = imageState.marginTop;
    }
    else {
        if (imageState.marginRight) {
            imageStyles.marginRight = imageState.marginRight;
        }
        if (imageState.marginBottom) {
            imageStyles.marginBottom = imageState.marginBottom;
        }
        if (imageState.marginLeft) {
            imageStyles.marginLeft = imageState.marginLeft;
        }
    }
    if (imageState.borderRadius) {
        imageStyles.borderRadius = imageState.borderRadius;
    }
    if (imageState.horizontalAlign === "left") {
        imageStyles.float = "left";
    }
    if (imageState.horizontalAlign === "right") {
        imageStyles.float = "right";
    }
    if (imageState.height && imageState.width) {
        imageStyles.aspectRatio = imageState.isAspectRatioLocked
            ? `${imageState.naturalWidth} / ${imageState.naturalHeight}`
            : `${parseFloat(String(imageState.width))} / ${parseFloat(String(imageState.height))}`;
    }
    if (imageState.horizontalAlign === "center") {
        imageStyles.marginRight = "auto";
        imageStyles.marginLeft = "auto";
        imageStyles.display = "block";
    }
    else {
        imageStyles.display = "inline-block";
    }
    if (imageState.verticalAlign && imageState.verticalAlign !== "baseline") {
        imageStyles.verticalAlign = imageState.verticalAlign;
    }
    numericCssProperties.forEach((key) => {
        if (key in imageStyles) {
            // Convert number strings to numbers
            imageStyles[key] = toCssValue(imageStyles[key]);
        }
    });
    return imageStyles;
};
export const toNumberOrCssValue = (value) => (/^\d*\.?\d*$/.test(value) ? Number(value) : value);
export const updateImage = (editor, element, { href, target, ...newState }) => {
    const path = ReactEditor.findPath(editor, element);
    const { children, type, ...imageProperties } = element;
    Transforms.setNodes(editor, { type: "image", ...imageStateReducer(imageProperties, newState) }, { at: path });
};
export const deleteImage = (editor, element) => {
    const path = ReactEditor.findPath(editor, element);
    const previousPath = Path.previous(path);
    // move selection to something that won't get deleted
    Transforms.select(editor, previousPath);
    Transforms.collapse(editor, { edge: "end" });
    Transforms.removeNodes(editor, { at: path });
    // restore focus to editor at position where image used to be
    focusEditor(editor);
};
